import { render } from "./chef-meals-table.vue?vue&type=template&id=550dfc04&scoped=true"
import script from "./chef-meals-table.vue?vue&type=script&lang=js"
export * from "./chef-meals-table.vue?vue&type=script&lang=js"

import "./chef-meals-table.vue?vue&type=style&index=0&id=550dfc04&lang=scss&scoped=true"

import exportComponent from "/Users/girgisnabil/Documents/projects/home-food-plus-full-stack/source/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-550dfc04"]])

export default __exports__